<template>
  <!-- <div
    v-if="showBottomNav"
    class="h-screen flex flex-col justify-end mobile-oriented"
  >
    <div class="flex-1 overflow-y-scroll overflow-x-hidden">
      <slot />
    </div>
    <m-bottom-nav class="flex-none" />
  </div>
  <div v-else class="mobile-oriented"><slot /></div> -->
  <div class="mobile-oriented">
    <slot />
  </div>
</template>

<script lang="ts">
import MBottomNav from "@/components/MBottomNav.vue";
import store from "@/store";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    MBottomNav
  }
})
export default class MPageTemplate extends Vue {
  get isInLiff(): boolean {
    return store.state.isInLiff;
  }

  get showBottomNav(): boolean {
    if (this.$route.meta.pageType === "other") {
      return false;
    }
    return !this.isInLiff;
  }
}
</script>

<style scoped>
.mobile-oriented {
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
}
</style>
